"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTimestampStringToDateTimeString = transformTimestampStringToDateTimeString;
const transformDateTimeToString_1 = require("./transformDateTimeToString");
const transformTimestampStringToDate_1 = require("./transformTimestampStringToDate");
function transformTimestampStringToDateTimeString(timestampString) {
    return (0, transformDateTimeToString_1.transformDateTimeToString)((0, transformTimestampStringToDate_1.transformTimestampStringToDate)(timestampString));
}
//# sourceMappingURL=transformTimestampStringToDateTimeString.js.map